import { createContext } from 'react';

import type { getColors } from 'theme/constants/colors';
import createContextHelpers from 'utils/create-context-helpers';

type Colors = ReturnType<typeof getColors>;

// Preserve the original context's `undefined` runtime default while exposing the value
// supplied by the app-level provider as the real, inferred color-token shape. Consumers
// were already written under the invariant that ColorsProvider is always present.
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const ColorsContext = createContext<Colors>(undefined!);
export const { ColorsProvider, useColors, withColors } = createContextHelpers(ColorsContext, 'colors');
